import * as React from 'react';
import Col from 'react-bootstrap/Col'; 
import Row from 'react-bootstrap/Row';
import Container from 'react-bootstrap/Container';
import AppSettings from '../types/AppSettings';
import { Button } from 'react-bootstrap';

type ErrorPageProps = {
    settings: AppSettings;
    error: Error;
}

export default class ErrorPage extends React.Component<ErrorPageProps> {
    public render() {
        return (
            <Container className="error-page text-center mt-5">
                <Row className="mb-3">
                    <Col>
                        <img
                            src={this.props.settings.squareLogoAsset}
                            className="logo-secondary"
                            alt="Konica Minolta"
                        />
                    </Col>
                </Row>
                <Row className="mb-3">
                    <Col>
                        <h3 className="text-danger">You have encountered an error!</h3>
                    </Col>
                </Row>
                <Row>
                    <Col md={6} className="text-right">
                        <strong>Error Type:</strong>
                    </Col>
                    <Col md={6} className="text-left">
                        {this.props.error.name}
                    </Col>
                </Row>
                <Row>
                    <Col md={6} className="text-right">
                        <strong>Error Message:</strong>
                    </Col>
                    <Col md={6} className="text-left">
                        {this.props.error.message}
                    </Col>
                </Row>
                {(this.props.error.stack !== undefined) && 
                <Row>
                    <Col md={6} className="text-right">
                        <strong>Stack:</strong>
                    </Col>
                    <Col md={6} className="text-left">
                        <pre>
                            {this.props.error.stack}
                        </pre>
                    </Col>
                </Row>
                }
                <Row>
                    <Col md={12} className="text-center">
                        <a href={`${window.location.protocol}//${window.location.host}`}>
                            <Button variant="primary">Return Home</Button>
                        </a>
                    </Col>
                </Row>
            </Container>
        );
    }
}